import classes from './Tag.module.css'

const Tag = ({children, type, color}) => {
    return <div className={`${classes.tag} ${type ? classes[type] : ''} ${color ? classes[color] : classes.no_color}`}>{children}</div>
}

export default Tag